import store from '@/core/store'

class DropdownService {
  constructor () {
    this.isOpen = false
    this.close = this.close.bind(this)
    this.coordinates = {}
  }

  open (menuOptions, position, event) {
    if (this.isOpen) {
      store.commit('DROPDOWN:CLOSE')
    }
    this.coordinates = {
      top: event.target.getBoundingClientRect().top,
      left: event.target.getBoundingClientRect().left,
      position: 'absolute',
    }

    store.commit('DROPDOWN:OPEN', {
      menuOptions,
      coordinates: this.coordinates,
      position,
    })
    this.isOpen = true
    window.addEventListener('click', this.close)
    Array.from(document.getElementsByClassName('scrollable-list')).forEach((element) => {
      element.addEventListener('scroll', this.close)
    })
  }

  close () {
    this.isOpen = false
    this.coordinates = {}
    window.removeEventListener('click', this.close)
    Array.from(document.getElementsByClassName('scrollable-list')).forEach((element) => {
      element.removeEventListener('scroll', this.close)
    })
    store.commit('DROPDOWN:CLOSE')
  }

  isOpenedForThisTarget (event) {
    const {
      top,
      left
    } = event.target.getBoundingClientRect()
    return this.isOpen && top === this.coordinates.top && left === this.coordinates.left
  }
}

export default new DropdownService()
